<template>

    <two-factor-login-flow
        :title="$t('two_factor_required.title')"
        :introBold="$t('two_factor_required.intro_bold')"
        :intro="$t('two_factor_required.intro')"
        :introButton="$t('two_factor_required.intro_button')"
        :footer="$t('two_factor_required.footer')"
        :verifyStep1="$t('two_factor_config.step_1')"
        :verifyStep2="$t('two_factor_config.step_2')"
        :verifyStep3="$t('two_factor_config.step_3')"
        :footerSmall="true"
        />

</template>

<script>
import TwoFactorLoginFlow from './TwoFactorLoginFlow.vue';

export default {
    components: {
        'two-factor-login-flow': TwoFactorLoginFlow
    },
}
</script>
